export default "__VITE_ASSET__D0AH17rw__"